import apiClient from './client'

export const postService = {
  getPosts: (params = {}) => apiClient.get('/posts', { params }),

  createPost: (data) => apiClient.post('/posts', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),

  getPostById: (id) => apiClient.get(`/posts/${id}`),

  updatePost: (id, data) => apiClient.put(`/posts/${id}`, data),

  deletePost: (id) => apiClient.delete(`/posts/${id}`),

  getPendingPosts: () => apiClient.get('/posts/pending'),

  getPostsByType: (type, params = {}) => apiClient.get('/posts/type', { params: { type, ...params } }),

  approvePost: (id) => apiClient.put(`/posts/${id}/approve`),

  rejectPost: (id, reason) => apiClient.put(`/posts/${id}/reject`, { reason }),

  archivePost: (id) => apiClient.put(`/posts/${id}/archive`),

  incrementView: (id) => apiClient.post(`/posts/${id}/view`),
}

export default postService
